export const QUICK_NAV_ID = "QuickNavId";
